import React from "react";
import { Grid } from "@material-ui/core";
import "./inputIconPlusHL.css";

const InputIconPlusHLPure = (props) => {
  const {
    typeInput, //Type input (text, email, number, etc.)
    valueInput, //If it has a predefined value or a start value
    // validateInput,
    handleChangeInput, //Function onChange for value change
    disabled, //disabled input
    errorInput, //Error true or false
    errorInputText, //Error text to validate input
  } = props;

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  // const [inputValue, setInputValue] = useState(valueInput || "");
  // const [errorInput, setErrorInput] = useState(false);

  // const handleChange = (event) => {
  //   if (event.target.value === undefined || event.target.value === "") {
  //     setErrorInput(true);
  //   } else {
  //     setInputValue(event.target.value);
  //   }
  // };

  return (
    <Grid
      item
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className="inputIconSearchHLPure-container"
    >
      <div className="inputIconSearchHLPure-container-text">
        <i className="inputIconSearchHLPure-icon k-icon k-i-plus"></i>
      </div>
      <input
        type={typeInput}
        className="inputIconSearchHLPure-input"
        name="inputValue"
        value={valueInput || ""}
        onChange={handleChangeInput}
        // component={validateInput}
        disabled={disabled}
      />

      {/* {errorInput && (
        <span className="hint-message-error">{errorInputText}</span>
      )} */}
    </Grid>
  );
};

export { InputIconPlusHLPure as default };
